<h1 class="mb-4 text-center" [ngSwitch]="error403">
  <ng-container *ngSwitchCase="true" i18n="@@error.403title">Unauthorized</ng-container>
  <ng-container *ngSwitchDefault i18n="@@error.title">Error</ng-container>
</h1>

<div *ngIf="errorMessage">
  <p class="text-danger">{{errorMessage}}</p>
</div>

<div class="text-center" *ngIf="error403">
  <p class="mb-2" i18n="@@error.message.403">
    You are no longer logged in or you are not authorized to access this page.
  </p>
  <p>
    <ng-container i18n="@@error.label.signIn">
      Please <a href="javascript:void(0);" (click)="login()">sign in</a> again.
    </ng-container>
  </p>
</div>
<div class="my-5"></div>